import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/proxy/updatePackageOffers', request)
}

export {put}
